import React from 'react';

import styles from './index.scss';

export * from './components';

interface Props {
  children: any;
}

const Card: React.FC<Props> = ({ children }) => <div className={styles.card}>{children}</div>;

export default Card;
